<template>
  <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.883301" y="4.47217" width="11.0039" height="10.4779" rx="1.25" stroke="white" stroke-width="1.5"/>
    <path d="M9.41876 6.94113V3.40137C9.41876 2.2968 8.52333 1.40137 7.41876 1.40137H5.35205C4.24748 1.40137 3.35205 2.2968 3.35205 3.40137V6.94113" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
  </svg>

</template>
